/* eslint-disable node/no-unsupported-features/es-syntax */
import { SETTINGS_ROUTE_NAMES } from "@/shared";

export const SETTINGS_ROUTES = [
    {
        name: SETTINGS_ROUTE_NAMES.INDEX,
        component: () => import("../ui/SettingsPage.vue"),
        meta: {
            title: "words.settings_section",
        },
        path: "/settings",
    },
    {
        name: SETTINGS_ROUTE_NAMES.CATEGORY_EDITOR,
        component: () => import("../ui/SettingsCategoriesPage.vue"),
        meta: {
            title: "words.categories",
        },
        path: "/settings/categories",
    },
    {
        name: SETTINGS_ROUTE_NAMES.CONTRACTS_LIST,
        component: () => import("../ui/SettingsContractsPage.vue"),
        meta: {
            title: "words.contract_templates",
        },
        path: "/settings/contracts",
    },
    {
        name: SETTINGS_ROUTE_NAMES.CONTRACTS_ADD,
        component: () => import("../ui/SettingsContractsAddPage.vue"),
        meta: {
            title: "words.add_template",
        },
        path: "/settings/contracts/add",
    },
    {
        name: SETTINGS_ROUTE_NAMES.CONTRACTS_EDIT,
        component: () => import("../ui/SettingsContractsEditPage.vue"),
        path: "/settings/contracts/edit/:id",
        meta: {
            title: "words.edit_template",
        },
        props: true,
    },
    {
        name: SETTINGS_ROUTE_NAMES.INTEGRATIONS,
        component: () => import("../ui/SettingsIntegrations.vue"),
        meta: {
            title: "words.integrations_section",
        },
        path: "/settings/integrations",
    },
];
